export enum CellDataType {
  TEXT = 'text',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATE_STRING = 'dateString',
  OBJECT = 'object'
}
